"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initAmplitude = initAmplitude;
exports.trackEvent = trackEvent;
exports.setTrackingUser = setTrackingUser;
exports.resetTrackingUser = resetTrackingUser;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _config = _interopRequireDefault(require("next/config"));

var _helpers = require("../../registration/auth/helpers");

var _general = require("../../../helpers/general");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _getConfig = (0, _config["default"])(),
    _getConfig$publicRunt = _getConfig.publicRuntimeConfig,
    AMPLITUDE_ENABLED = _getConfig$publicRunt.AMPLITUDE_ENABLED,
    AMPLITUDE_API_KEY = _getConfig$publicRunt.AMPLITUDE_API_KEY;

var logStyles = 'color:#c4aa84; font-weight:bold;';

var hasWindow = function hasWindow() {
  return typeof window !== 'undefined';
}; // lazy evaluation because this can run on the server too


var isAmplitudeEnabled = function isAmplitudeEnabled() {
  return hasWindow() && AMPLITUDE_ENABLED;
}; // https://github.com/amplitude/Amplitude-JavaScript/issues/110
// Amplitude must have a window


var amplitude;

if (isAmplitudeEnabled()) {
  // eslint-disable-next-line global-require
  amplitude = require('amplitude-js');
}

var hasAmplitude = function hasAmplitude() {
  return isAmplitudeEnabled() && typeof amplitude !== 'undefined';
};

function initAmplitude() {
  if (hasWindow()) {
    (0, _general.debug)("%c amplitude \u2022 init amplitude", "".concat(logStyles), "ENABLED: ".concat(hasAmplitude()));
  }

  if (!hasAmplitude()) return; // https://developers.amplitude.com/docs/disabling-automatic-tracking-of-properties#disabling-tracking-on-javascript
  // https://amplitude.github.io/Amplitude-JavaScript/#amplitudeclientinit

  amplitude.getInstance().init(AMPLITUDE_API_KEY, null, {
    trackingOptions: {
      city: false,
      country: false,
      carrier: false,
      device_manufacturer: false,
      device_model: false,
      dma: false,
      ip_address: false,
      language: false,
      os_name: false,
      os_version: false,
      platform: false,
      region: false,
      version_name: true
    }
  });
}

function trackEvent(event) {
  var eventProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var eventName = event.name;
  var staticProps = event.eventProps || {};

  var props = _objectSpread(_objectSpread({}, staticProps), eventProps);

  if (hasWindow()) {
    (0, _general.debug)("%c amplitude \u2022 tracker \"".concat(eventName, "\" on the way"), "".concat(logStyles), "ENABLED: ".concat(hasAmplitude()), props);
  }

  if (!hasAmplitude()) return;
  amplitude.getInstance().logEvent(eventName, props);
}

function setTrackingUser(user) {
  if (!user) return;

  var _getUserRole = (0, _helpers.getUserRole)(user),
      role = _getUserRole.role;

  var userProps = {
    user_type: role
  };

  if (hasWindow()) {
    (0, _general.debug)("%c amplitude \u2022 setting user slug \"".concat(user.slug, "\""), "".concat(logStyles), "ENABLED: ".concat(hasAmplitude()), userProps);
  }

  if (!hasAmplitude()) return; // https://developers.amplitude.com/docs/setting-custom-user-ids

  amplitude.getInstance().setUserId(user.slug);
  amplitude.getInstance().setUserProperties(userProps);
} // https://help.amplitude.com/hc/en-us/articles/115003135607-Tracking-Unique-Users
// https://developers.amplitude.com/docs/setting-custom-user-ids#logging-out-and-anonymous-users


function resetTrackingUser() {
  if (hasWindow()) {
    (0, _general.debug)("%c amplitude \u2022 reseting tracking user", "".concat(logStyles), "ENABLED: ".concat(hasAmplitude()));
  }

  if (!hasAmplitude()) return;
  amplitude.getInstance().setUserId(null); // not string 'null'

  amplitude.getInstance().regenerateDeviceId();
}